(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-announcement-bar-holm"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initAnnbar(root) {
    if (!root || root.dataset.abInit === '1') return;
    root.dataset.abInit = '1';

    var slides = Array.prototype.slice.call(root.querySelectorAll('.annbar-holm__slide'));
    if (slides.length < 2) return;

    var autoplay = root.dataset.autoplay === 'true';
    if (!autoplay) return;

    var interval = parseInt(root.dataset.interval, 10) || 5000;
    var current = 0;
    var timer = null;
    var startTime = 0;
    var remaining = interval;

    function goTo(index) {
      var total = slides.length;
      var next = ((index % total) + total) % total;
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === next);
      });
      current = next;
      start(interval);
    }

    function start(ms) {
      clearTimeout(timer);
      remaining = ms;
      startTime = Date.now();
      timer = setTimeout(function () { goTo(current + 1); }, ms);
    }

    root.addEventListener('mouseenter', function () {
      clearTimeout(timer);
      remaining = remaining - (Date.now() - startTime);
    });

    root.addEventListener('mouseleave', function () {
      if (remaining < 300) remaining = 300;
      startTime = Date.now();
      clearTimeout(timer);
      timer = setTimeout(function () { goTo(current + 1); }, remaining);
    });

    root.addEventListener('annbar:select', function (e) {
      clearTimeout(timer);
      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === e.detail.index);
      });
      current = e.detail.index;
    });

    start(interval);
  }

  function initAll(scope) {
    var container = scope || document;
    Array.prototype.slice.call(container.querySelectorAll('.annbar-holm')).forEach(initAnnbar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });

  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest ? e.target.closest('.annbar-holm__slide') : null;
    if (!slide) return;
    var root = slide.closest('.annbar-holm');
    if (!root) return;
    root.dispatchEvent(new CustomEvent('annbar:select', {
      detail: { index: parseInt(slide.dataset.index, 10) || 0 }
    }));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-collection-grid-holm"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initPgrid(root) {
    if (!root || root.dataset.pgInit === '1') return;
    root.dataset.pgInit = '1';

    var track = root.querySelector('[data-pg-track]');
    var prev = root.querySelector('[data-pg-prev]');
    var next = root.querySelector('[data-pg-next]');
    if (!track) return;

    function step() {
      var card = track.querySelector('.pgrid-holm__card');
      if (!card) return track.clientWidth;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function updateArrows() {
      if (!prev || !next) return;
      var maxScroll = track.scrollWidth - track.clientWidth - 2;
      prev.style.opacity = track.scrollLeft <= 2 ? '0.25' : '1';
      next.style.opacity = track.scrollLeft >= maxScroll ? '0.25' : '1';
    }

    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    updateArrows();
  }

  function initAll(scope) {
    var container = scope || document;
    Array.prototype.slice.call(container.querySelectorAll('.pgrid-holm')).forEach(initPgrid);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-faq-holm"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initFaq(root) {
    if (!root || root.dataset.faqInit === '1') return;
    root.dataset.faqInit = '1';

    var items = Array.prototype.slice.call(root.querySelectorAll('[data-faq-item]'));
    if (items.length === 0) return;

    var single = root.dataset.singleOpen === 'true';

    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!single || !item.open) return;
        items.forEach(function (other) {
          if (other !== item && other.open) other.open = false;
        });
      });
    });
  }

  function initAll(scope) {
    var container = scope || document;
    Array.prototype.slice.call(container.querySelectorAll('.faq-holm')).forEach(initFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });

  document.addEventListener('shopify:block:select', function (e) {
    var item = e.target.closest ? e.target.closest('[data-faq-item]') : null;
    if (item) item.open = true;
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-footer-holm"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initFooter(root) {
    if (!root || root.dataset.ftInit === '1') return;
    root.dataset.ftInit = '1';

    var heads = Array.prototype.slice.call(root.querySelectorAll('[data-footer-toggle]'));

    heads.forEach(function (head) {
      head.addEventListener('click', function () {
        if (window.innerWidth > 749) return;
        if (!root.classList.contains('footer-holm--collapsible')) return;

        var col = head.parentNode;
        var body = col.querySelector('[data-footer-body]');
        if (!body) return;

        var isOpen = body.classList.toggle('is-open');
        head.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });
  }

  function initAll(scope) {
    var container = scope || document;
    Array.prototype.slice.call(container.querySelectorAll('.footer-holm')).forEach(initFooter);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-hero-slider-holm"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initHero(root) {
    if (!root || root.dataset.holmInit === '1') return;
    root.dataset.holmInit = '1';

    var slides = Array.prototype.slice.call(root.querySelectorAll('.hero-holm__slide'));
    if (slides.length === 0) return;

    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-hero-dot]'));
    var prevBtn = root.querySelector('[data-hero-prev]');
    var nextBtn = root.querySelector('[data-hero-next]');

    var autoplay = root.dataset.autoplay === 'true' && slides.length > 1;
    var interval = parseInt(root.dataset.interval, 10) || 6000;

    var current = 0;
    var timer = null;
    var startTime = 0;
    var remaining = interval;

    function resetActiveBar() {
      var activeDot = root.querySelector('.hero-holm__dot.is-active');
      if (!activeDot) return;
      var fill = activeDot.querySelector('.hero-holm__bar-fill');
      if (!fill) return;
      fill.style.animation = 'none';
      void fill.offsetWidth;
      fill.style.animation = '';
    }

    function startTimer(ms) {
      if (!autoplay) return;
      clearTimeout(timer);
      remaining = ms;
      startTime = Date.now();
      timer = setTimeout(function () { goTo(current + 1); }, ms);
    }

    function pause() {
      if (!autoplay) return;
      clearTimeout(timer);
      remaining = remaining - (Date.now() - startTime);
      root.classList.add('is-paused');
    }

    function resume() {
      if (!autoplay) return;
      if (remaining < 300) remaining = 300;
      root.classList.remove('is-paused');
      startTime = Date.now();
      clearTimeout(timer);
      timer = setTimeout(function () { goTo(current + 1); }, remaining);
    }

    function goTo(index) {
      var total = slides.length;
      var next = ((index % total) + total) % total;

      slides.forEach(function (slide, i) {
        slide.classList.toggle('is-active', i === next);
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === next);
      });

      current = next;
      root.classList.remove('is-paused');
      resetActiveBar();
      startTimer(interval);
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.dataset.index, 10) || 0);
      });
    });

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

    root.addEventListener('mouseenter', pause);
    root.addEventListener('mouseleave', resume);

    var touchStartX = 0;
    var touchStartY = 0;
    root.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].clientX;
      touchStartY = e.changedTouches[0].clientY;
      pause();
    }, { passive: true });

    root.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - touchStartX;
      var dy = e.changedTouches[0].clientY - touchStartY;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) {
        goTo(dx < 0 ? current + 1 : current - 1);
      } else {
        resume();
      }
    }, { passive: true });

    root.addEventListener('holm:select', function (e) {
      goTo(e.detail.index);
      pause();
    });

    resetActiveBar();
    startTimer(interval);
  }

  function initAll(scope) {
    var container = scope || document;
    var heroes = Array.prototype.slice.call(container.querySelectorAll('.hero-holm'));
    heroes.forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });

  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest ? e.target.closest('.hero-holm__slide') : null;
    if (!slide) return;
    var root = slide.closest('.hero-holm');
    if (!root) return;
    root.dispatchEvent(new CustomEvent('holm:select', {
      detail: { index: parseInt(slide.dataset.index, 10) || 0 }
    }));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-recently-viewed-holm"] && !Shopify.designMode) return;
  try {
    
(function () {
  var STORAGE_KEY = 'holm:recently-viewed';
  var MAX_STORED = 20;

  function readList() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Array.isArray(arr) ? arr : [];
    } catch (e) {
      return [];
    }
  }

  function writeList(list) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, MAX_STORED)));
    } catch (e) {}
  }

  function prettify(handle) {
    return handle
      .split('-')
      .filter(Boolean)
      .join(' ')
      .replace(/^\S/, function (c) { return c.toUpperCase(); });
  }

  function setupBackButton(root) {
    var wrap = root.querySelector('[data-rcv-back]');
    if (!wrap) return;

    var ref = document.referrer;
    if (!ref) return;

    var url;
    try {
      url = new URL(ref);
    } catch (e) {
      return;
    }

    if (url.origin !== window.location.origin) return;

    var match = url.pathname.match(/\/collections\/([^\/\?#]+)/);
    if (!match) return;

    var handle = match[1];
    if (handle === 'all') return;

    var link = wrap.querySelector('[data-rcv-back-link]');
    var label = wrap.querySelector('[data-rcv-back-label]');
    if (!link || !label) return;

    link.href = '/collections/' + handle;
    label.textContent = (label.textContent || '').trim() + ' ' + prettify(handle);
    wrap.hidden = false;
  }

  function initRcv(root) {
    if (!root || root.dataset.rcInit === '1') return;
    root.dataset.rcInit = '1';

    var currentId = root.dataset.currentId;
    var list = readList();

    if (currentId) {
      list = list.filter(function (id) { return String(id) !== String(currentId); });
      list.unshift(currentId);
      writeList(list);
      list = list.filter(function (id) { return String(id) !== String(currentId); });
    }

    setupBackButton(root);

    var limit = parseInt(root.dataset.limit, 10) || 4;
    var ids = list.slice(0, limit);
    if (ids.length === 0) return;

    var query = ids
      .map(function (id) { return 'id:' + id; })
      .join(' OR ');

    var searchUrl = root.dataset.searchUrl || '/search';
    var url =
      searchUrl +
      '?section_id=' + encodeURIComponent(root.dataset.sectionId) +
      '&type=product&options[unavailable_products]=last&q=' +
      encodeURIComponent(query);

    fetch(url)
      .then(function (r) {
        if (!r.ok) throw new Error('bad response');
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var grid = doc.querySelector('[data-rcv-grid]');
        var target = root.querySelector('[data-rcv-target]');
        if (!grid || !target || grid.children.length === 0) return;

        target.appendChild(document.importNode(grid, true));
        root.hidden = false;
      })
      .catch(function () {});
  }

  function initAll(scope) {
    var container = scope || document;
    Array.prototype.slice.call(container.querySelectorAll('[data-rcv-holm]')).forEach(initRcv);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-reviews-holm"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initRevw(root) {
    if (!root || root.dataset.rvInit === '1') return;
    root.dataset.rvInit = '1';

    var track = root.querySelector('[data-revw-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-revw-slide]'));
    var dotsWrap = root.querySelector('[data-revw-dots]');
    var prev = root.querySelector('[data-revw-prev]');
    var next = root.querySelector('[data-revw-next]');
    if (!track || slides.length === 0) return;

    var autoplay = root.dataset.autoplay === 'true';
    var interval = parseInt(root.dataset.interval, 10) || 6000;
    var index = 0;
    var timer = null;

    function perView() {
      var w = window.innerWidth;
      if (w <= 749) return 1;
      if (w <= 989) return 2;
      return parseInt(root.dataset.perView, 10) || 3;
    }

    function maxIndex() {
      return Math.max(0, slides.length - perView());
    }

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      for (var i = 0; i <= maxIndex(); i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'revw-holm__dot';
        b.setAttribute('aria-label', 'Slide ' + (i + 1));
        (function (n) {
          b.addEventListener('click', function () { goTo(n, true); });
        })(i);
        dotsWrap.appendChild(b);
      }
    }

    function syncDots() {
      if (!dotsWrap) return;
      var dots = dotsWrap.children;
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('is-active', i === index);
      }
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index >= maxIndex();
    }

    function apply() {
      var slideW = slides[0].getBoundingClientRect().width;
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      track.style.transform = 'translateX(-' + index * (slideW + gap) + 'px)';
      syncDots();
    }

    function goTo(n, manual) {
      var max = maxIndex();
      if (n < 0) n = max;
      if (n > max) n = 0;
      index = n;
      apply();
      if (manual) restart();
    }

    function restart() {
      if (!autoplay) return;
      clearInterval(timer);
      timer = setInterval(function () { goTo(index + 1); }, interval);
    }

    if (prev) prev.addEventListener('click', function () { goTo(index - 1, true); });
    if (next) next.addEventListener('click', function () { goTo(index + 1, true); });

    root.addEventListener('mouseenter', function () { clearInterval(timer); });
    root.addEventListener('mouseleave', restart);

    var startX = 0;
    root.addEventListener('touchstart', function (e) {
      startX = e.changedTouches[0].clientX;
      clearInterval(timer);
    }, { passive: true });

    root.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 45) {
        goTo(dx < 0 ? index + 1 : index - 1, true);
      } else {
        restart();
      }
    }, { passive: true });

    var rebuild = function () {
      if (index > maxIndex()) index = maxIndex();
      buildDots();
      apply();
    };

    window.addEventListener('resize', rebuild);

    buildDots();
    apply();
    restart();
  }

  function initAll(scope) {
    var container = scope || document;
    Array.prototype.slice.call(container.querySelectorAll('.revw-holm')).forEach(initRevw);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-scroll-top-holm"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initScrollTop(root) {
    if (!root || root.dataset.stInit === '1') return;
    root.dataset.stInit = '1';

    var button = root.querySelector('[data-scrolltop]');
    if (!button) return;

    var threshold = parseInt(root.dataset.threshold, 10) || 400;
    var ticking = false;

    button.removeAttribute('hidden');

    function update() {
      var y = window.pageYOffset || document.documentElement.scrollTop;
      button.classList.toggle('is-visible', y > threshold);
      ticking = false;
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', onScroll, { passive: true });

    button.addEventListener('click', function () {
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    });

    update();
  }

  function initAll(scope) {
    var container = scope || document;
    Array.prototype.slice.call(container.querySelectorAll('.scrolltop-holm')).forEach(initScrollTop);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lg-customer-stories"] && !Shopify.designMode) return;
  try {
    
  function initLgStories(root) {
    if (!root || root.dataset.lgStoriesInit === 'true') return;
    root.dataset.lgStoriesInit = 'true';

    var viewport = root.querySelector('.lg-stories__viewport');
    var track = root.querySelector('.lg-stories__track');
    if (!viewport || !track) return;

    var autoplay = root.dataset.autoplay === 'true';
    var dir = root.dataset.direction === 'right' ? -1 : 1;
    var speed = parseFloat(root.dataset.speed) || 10;
    var reduceMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!autoplay || reduceMotion) return;

    var paused = false;
    var inView = true;
    var half = 0;
    var lastTime = null;
    var rafId = null;
    var resumeTimer = null;
    var resizeTimer = null;

    function measure() {
      half = track.scrollWidth / 2;
    }

    function pause() {
      paused = true;
    }

    function resume() {
      paused = false;
      lastTime = null;
    }

    function resumeAfterDelay() {
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(resume, 1000);
    }

    function step(ts) {
      if (lastTime === null) lastTime = ts;
      var dt = (ts - lastTime) / 1000;
      lastTime = ts;

      if (!paused && inView && half > 0) {
        var next = viewport.scrollLeft + dir * speed * dt;
        if (next >= half) {
          next -= half;
        } else if (next < 0) {
          next += half;
        }
        viewport.scrollLeft = next;
      }

      rafId = requestAnimationFrame(step);
    }

    measure();

    viewport.addEventListener('mouseenter', pause);
    viewport.addEventListener('mouseleave', resume);
    viewport.addEventListener('touchstart', pause, { passive: true });
    viewport.addEventListener('touchend', resumeAfterDelay);
    viewport.addEventListener('pointerdown', pause);
    viewport.addEventListener('pointerup', resumeAfterDelay);
    viewport.addEventListener('focusin', pause);
    viewport.addEventListener('focusout', resume);

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            inView = entry.isIntersecting;
          });
        },
        { rootMargin: '200px', threshold: 0 }
      );
      io.observe(root);
    }

    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(measure, 200);
    });

    rafId = requestAnimationFrame(step);

    root._lgStoriesCleanup = function () {
      if (rafId) cancelAnimationFrame(rafId);
      clearTimeout(resumeTimer);
      clearTimeout(resizeTimer);
    };
  }

  function initAllLgStories(scope) {
    (scope || document).querySelectorAll('[data-lg-stories]').forEach(initLgStories);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllLgStories();
    });
  } else {
    initAllLgStories();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAllLgStories(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var el = event.target.querySelector('[data-lg-stories]');
    if (el && el._lgStoriesCleanup) el._lgStoriesCleanup();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["selector-colecciones-vertice"] && !Shopify.designMode) return;
  try {
    
  class VwCollectionsSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.dots = Array.from(this.querySelectorAll('[data-dot]'));
      if (!this.track || this.dots.length === 0) return;

      this.rafId = null;
      this.onScroll = this.onScroll.bind(this);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });

      this.dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          const item = this.track.children[index];
          if (!item) return;
          const pad = parseFloat(getComputedStyle(this.track).paddingLeft) || 0;
          this.track.scrollTo({ left: item.offsetLeft - pad, behavior: 'smooth' });
        });
      });

      this.setActive(0);
    }

    disconnectedCallback() {
      if (this.track) this.track.removeEventListener('scroll', this.onScroll);
    }

    onScroll() {
      if (this.rafId) return;
      this.rafId = requestAnimationFrame(() => {
        this.rafId = null;
        const pad = parseFloat(getComputedStyle(this.track).paddingLeft) || 0;
        const scrollLeft = this.track.scrollLeft;
        let closest = 0;
        let minDistance = Infinity;

        Array.from(this.track.children).forEach((item, index) => {
          const distance = Math.abs(item.offsetLeft - pad - scrollLeft);
          if (distance < minDistance) {
            minDistance = distance;
            closest = index;
          }
        });

        this.setActive(closest);
      });
    }

    setActive(index) {
      this.dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
    }
  }

  if (!customElements.get('vw-collections-slider')) {
    customElements.define('vw-collections-slider', VwCollectionsSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
